export const hasCookieBannerInteraction = () => {
  const cookieSettings = localStorage.getItem('sp_consent') || '[]';

  try {
    const parsedCookieSettings = JSON.parse(cookieSettings);

    if (!parsedCookieSettings.length) {
      return false;
    }

    return true;
  } catch (error) {
    return false;
  }
};
